export const initState = () => ({
    selectedWorker: null,
    selectedOrderItemsObj: {},
    onCloseAction: () => { },
});
const state = initState();
export default state;
